import index from '../objects/product/index';

index();
